export const theme = {
  colors: {
    background: '#fafafa',
    primary: '#e1e1e6',
    text: '#e1e1e6',
  },
};
